import logo from '../../assets/images/logo.jpg'
import { Link } from "react-router-dom";
import './Home.css'



const Home = () => {
  return (
    <div className='text-center mx-2 home'>
      <br/>
      <img className="d-block mx-auto imgHeader" src={logo} alt="logo" />
      <h1 className="display-5 fw-bold">To Do App</h1>
      <div className="col-lg-6 mx-auto my-auto">
        <p className="lead mb-4">Welcome to my app</p>
        <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
          <Link to={'/login'} type="button" className="btn btn-primary btn-lg px-4 gap-3">Login</Link>
          <Link to={'/register'} type="button" className="btn btn-outline-secondary btn-lg px-4">Register</Link>
        </div>
      </div>
    </div>
  )
}

export default Home